import { apiService } from 'core/services/apiService';

type CheckResponse = {
  data?: {
    last_users_legal_agreement_identifier: string | null;
    last_active_legal_agreement_identifier: string | null;
  }
};

const CheckUserLegalAgreement = async (): Promise<CheckResponse> => {
  const data = apiService.responseHandler(await apiService.get(`legal_agreements/user/check`));
  return data;
};

const GetLegalAgreements = async (): Promise<any[]> => {
  const data = apiService.responseHandler(await apiService.get(`legal_agreements`));
  return data?.member || [];
};

const PostUserAgreement = async (body: any): Promise<any> => {
  const data = apiService.responseHandler(await apiService.post(`legal_agreements/user/agreement`, body));
  return data;
};

export { CheckUserLegalAgreement, GetLegalAgreements, PostUserAgreement };
